<div class="modal-wrapper">
  <div class="modal-header">
    <h4 tabindex="0" ngbAutofocus class="modal-title">
      Place a bid
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning">You have <strong>{{auction.CurrentBidPoints}}</strong> points available.</div>
    <input id="bidpoints" [(ngModel)]="bidpoints" name="bidpoints" class="form-control" type="number" placeholder="00" (change)="validate()" (keyup.enter)="placeBid(bidpoints)" /><br />
    @if (pointserror) {
      <div class="alert alert-danger">You do not have enough points to place this bid.</div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="placeBid(bidpoints)" [disabled]="bidpoints <= 0 || pointserror">Place Bid</button>
  </div>
</div>
